import axios from 'axios'
import HTTP from './http'

export default {
    assert: payload => axios.get(payload, { responseType: 'arraybuffer' }),
    upload: (formData, params) => axios.post(HTTP.FILE, formData, { headers: { 'Content-Type': undefined }, params }),
    delete: payload => axios.delete(HTTP.FILE, { params: payload }),
    invoice: payload => axios.post(HTTP.INVOICE, { params: payload }),
    commissions: payload => axios.get(HTTP.COMMISSIONS, { params: payload }),
    commissionExports: payload => axios.get(HTTP.COMMISSION_EXPORTS, { params: payload }),
    generateParentSub: payload => axios.post(HTTP.GENERATE_PARENT_SUB),
    generateSmileSub: payload => axios.post(HTTP.GENERATE_SMILE_SUB),
    generateRdgReport: payload => axios.post(HTTP.GENERATE_RDG_REPORT, payload, { responseType: 'blob' }),
    generateAgeSub: payload => axios.post(HTTP.GENERATE_AGE_SUB),
    generateMonthlyCommissionFile: () => axios.post(HTTP.MONTHLY_COMMISSION_FILE),
    getClientInvoices: payload => axios.get(HTTP.GET_CLIENT_INVOICES, { params: payload }),
    getTranzilaInvoice: payload => axios.get(HTTP.GET_TRANZILA_INVOICE, { params: payload, responseType: 'arraybuffer' })
}
